package com.jingfangpai.common.orm.mapping

import kotlinx.serialization.Serializable
import com.jingfangpai.common.orm.mapping.enums.ContentType
import com.jingfangpai.common.data.type.DateTime
import com.jingfangpai.common.data.serializer.DateTimeSerializer
import com.jingfangpai.common.orm.mapping.enums.ContentEntityType
import com.jingfangpai.common.orm.mapping.enums.ContentStatus

@Serializable
open class Content(var id: String? = null){
	var type: ContentType? = null
	var isContainer: Boolean? = null
	var parentId: String? = null
	var index: String? = null
	var title: String? = null
	var content: String? = null
	@Serializable(with = DateTimeSerializer::class)
	var timestamp: DateTime? = null
	var weight: Int? = null
	var description: String? = null
	var entityId: String? = null
	var entityType: ContentEntityType? = null
	var createdBy: String? = null
	var status: ContentStatus? = null
	@Serializable(with = DateTimeSerializer::class)
	var createdOn: DateTime? = null

	override fun equals(other: Any?): Boolean {
		if (this === other) return true
		if (other == null || this::class != other::class) return false
		other as Content
		if (id != other.id) return false
		if (type != other.type) return false
		if (isContainer != other.isContainer) return false
		if (parentId != other.parentId) return false
		if (index != other.index) return false
		if (title != other.title) return false
		if (content != other.content) return false
		if (timestamp != other.timestamp) return false
		if (weight != other.weight) return false
		if (description != other.description) return false
		if (entityId != other.entityId) return false
		if (entityType != other.entityType) return false
		if (createdBy != other.createdBy) return false
		if (status != other.status) return false
		if (createdOn != other.createdOn) return false
		return true
	}

	override fun hashCode(): Int {
		var result = 0
		result = 31 * result + (id?.hashCode() ?: 0)
		result = 31 * result + (type?.hashCode() ?: 0)
		result = 31 * result + (isContainer?.hashCode() ?: 0)
		result = 31 * result + (parentId?.hashCode() ?: 0)
		result = 31 * result + (index?.hashCode() ?: 0)
		result = 31 * result + (title?.hashCode() ?: 0)
		result = 31 * result + (content?.hashCode() ?: 0)
		result = 31 * result + (timestamp?.hashCode() ?: 0)
		result = 31 * result + (weight?.hashCode() ?: 0)
		result = 31 * result + (description?.hashCode() ?: 0)
		result = 31 * result + (entityId?.hashCode() ?: 0)
		result = 31 * result + (entityType?.hashCode() ?: 0)
		result = 31 * result + (createdBy?.hashCode() ?: 0)
		result = 31 * result + (status?.hashCode() ?: 0)
		result = 31 * result + (createdOn?.hashCode() ?: 0)
		return result
	}

}
